import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { HTTPCONSTANTS } from '../http/http-constants';
import {
  AboutMetricsResponse,
  ABOUT_METRICS_FALLBACK,
} from '../models/about-metrics.model';

/**
 * Thin client for GET /api/stats/about-metrics. Shares a single in-flight
 * request across all About-page consumers so we hit the API once per page load.
 * The backend response is already cached server-side; on any error we resolve to
 * the central client-side fallback so the page always renders real figures.
 */
@Injectable({ providedIn: 'root' })
export class AboutMetricsService {
  private cached$: Observable<AboutMetricsResponse> | null = null;

  constructor(private http: HttpClient) {}

  getAboutMetrics(): Observable<AboutMetricsResponse> {
    if (this.cached$) return this.cached$;
    const url = `${HTTPCONSTANTS.dataApiProtocol}${HTTPCONSTANTS.dataApiBaseAddress}/stats/about-metrics`;
    this.cached$ = this.http.get<AboutMetricsResponse>(url).pipe(
      map((res) => res ?? ABOUT_METRICS_FALLBACK),
      catchError((err) => {
        console.error('AboutMetrics fetch failed:', err?.status ?? err?.message ?? err);
        return of(ABOUT_METRICS_FALLBACK);
      }),
      shareReplay(1),
    );
    return this.cached$;
  }
}
